"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedSearchDialog = exports.FilterExpression = exports.FilterOperator = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
const $ = require("jquery");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
const ExternalInput_1 = require("./ExternalInputs/ExternalInput");
require("./PropertyPageExtendedSearchFilter");
class StackItem {
    constructor(node, m_isOperator) {
        this.m_isOperator = m_isOperator;
        this.m_node = node;
        this.m_visited = 0;
    }
}
class FilterOperator {
    constructor(syntaxMode) {
        this.syntaxMode = syntaxMode;
    }
}
exports.FilterOperator = FilterOperator;
class FilterExpression {
    constructor(syntaxMode) {
        this.syntaxMode = syntaxMode;
    }
}
exports.FilterExpression = FilterExpression;
class ViewFilter {
}
class ExtendedSearchDialog extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName, buttonControlDef) {
        super(controlColl, currentInstance, methodName);
        this.buttonControlDef = buttonControlDef;
        this.windowContentCssClass = "eiExtendedSearchDialog";
        this.windowWidth = 885;
        this.windowHeight = 300;
    }
    initWindowContents() {
        let that = this;
        that.windowData.beginInit();
        ExtendedSearchDialog.initOperators();
        let fieldName = that.input.field.fieldName;
        let ftFieldName = "";
        if (that.input.field.isFTRepresentativeField) {
            fieldName = that.input.field.presentedField;
            ftFieldName = that.input.field.fieldName;
        }
        let currentConstraints = that.currentInstance.items[fieldName].value;
        let splitter = $("<div />")
            .addClass("splitter")
            .css("height", "100%")
            .appendTo(that.widgetContainer);
        that.filterDiv = $("<div />").appendTo(splitter);
        that.filterButtonDiv = $("<div class='filterButtons' />").appendTo(splitter);
        splitter.kendoSplitter({
            orientation: "vertical",
            panes: [
                { scrollable: true, resizable: false },
                { size: "40px" }
            ]
        });
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("FilterStringParse"),
            requestData: JSON.stringify({
                value: currentConstraints,
                typeId: that.typeId,
                fieldName,
                ftFieldName
            }),
            done: (data) => {
                let syntaxMode = data.syntaxMode;
                let filters = that.astToViewFilters(data.syntaxTree);
                let addFilter = (filter) => {
                    let div = $("<div />").appendTo(that.filterDiv);
                    div.synPropertyPageExtendedSearchFilter({
                        typeId: that.typeId,
                        mode: that.mode,
                        currentInstance: that.currentInstance,
                        controlKey: that.controlKey,
                        input: that.input,
                        controlColl: that.controlColl,
                        buttonControlDef: that.buttonControlDef,
                        filter,
                        allowedFilterVariables: data.allowedFilterVariables,
                        formatStrings: data.formatStrings,
                        allowedOperators: that.getAllowedOperators(that.input.field, syntaxMode),
                        allOperators: ExtendedSearchDialog.operators,
                        syntaxMode
                    });
                };
                for (let i = 0; i < filters.length; i++)
                    addFilter(filters[i]);
                $("<button type='button' class='btn moreButton'></button")
                    .html(Utilities_1.synUtil.Strings.getValue("dynpsearchdlgmore"))
                    .appendTo(that.filterButtonDiv)
                    .on("click", function () {
                    let lastFilter = that.filterDiv.find("div.synPropertyPageExtendedSearchFilter").last();
                    let f = lastFilter.synPropertyPageExtendedSearchFilter("getFilter");
                    let newFilter = $.extend(true, {}, f);
                    newFilter.externalOperator = f.externalOperator || "Or";
                    if (that.input.field.isFTField) {
                        // Bei FT-Feldern den bei der vorhergehenden "Zeile" eingetragenen Wert löschen, da er
                        // 1. nur stören würde
                        // 2. wenn dieser Eintrag nicht unter die ersten 500 der FT fällt, dann kommt es zu Fehlermeldungen, dass der Eintrag nicht "wiederhergestellt" werden konnte.
                        if (newFilter.operator.rExpression) {
                            newFilter.operator.rExpression.valueEscaped = "";
                            newFilter.operator.rExpression.valueUnescaped = "";
                            newFilter.operator.rExpression.valueFTField = "";
                        }
                        if (newFilter.operator.lExpression) {
                            // Gibt es zwar bei FT-Feldern nicht, wird aber trotzdem der Vollständigkeit halber implementiert
                            newFilter.operator.lExpression.valueEscaped = "";
                            newFilter.operator.lExpression.valueUnescaped = "";
                            newFilter.operator.lExpression.valueFTField = "";
                        }
                    }
                    addFilter(newFilter);
                });
            },
            fail(jqXHR, textStatus, errorThrown, url) {
                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                that.destroyWindow();
                that.callback(true, undefined, undefined, false);
            },
            cleanUp: () => { that.windowData.endInit(); }
        });
        return Promise.resolve();
    }
    getAllowedOperators(field, syntaxMode) {
        let arr = [];
        let isFtOrOLField = field.isFTRepresentativeField || field.isFTPresentedField;
        if (isFtOrOLField) {
            arr.push(ExtendedSearchDialog.operators["EqualExact"]);
            arr.push(ExtendedSearchDialog.operators["NotEqual"]);
            arr.push(ExtendedSearchDialog.operators["IsNull"]);
            arr.push(ExtendedSearchDialog.operators["IsNotNull"]);
        }
        else {
            switch (this.input.field.fieldType) {
                case "String":
                case "FixString":
                    if (syntaxMode === "DefaultSyntax") {
                        arr.push(ExtendedSearchDialog.operators["Contains"]);
                        arr.push(ExtendedSearchDialog.operators["NotContains"]);
                        arr.push(ExtendedSearchDialog.operators["EqualExact"]);
                        arr.push(ExtendedSearchDialog.operators["NotEqualExact"]);
                    }
                    else {
                        arr.push(ExtendedSearchDialog.operators["EqualExact"]);
                        arr.push(ExtendedSearchDialog.operators["NotEqualExact"]);
                    }
                    arr.push(ExtendedSearchDialog.operators["IsNull"]);
                    arr.push(ExtendedSearchDialog.operators["IsNotNull"]);
                    break;
                case "Digit":
                case "BigDigit":
                case "Float":
                case "Date":
                case "Time":
                case "DateTime":
                    arr.push(ExtendedSearchDialog.operators["Equal"]);
                    arr.push(ExtendedSearchDialog.operators["Greater"]);
                    arr.push(ExtendedSearchDialog.operators["Smaller"]);
                    arr.push(ExtendedSearchDialog.operators["GreaterOrEqual"]);
                    arr.push(ExtendedSearchDialog.operators["SmallerOrEqual"]);
                    arr.push(ExtendedSearchDialog.operators["Between"]);
                    arr.push(ExtendedSearchDialog.operators["NotEqual"]);
                    arr.push(ExtendedSearchDialog.operators["IsNull"]);
                    arr.push(ExtendedSearchDialog.operators["IsNotNull"]);
                    break;
            }
        }
        return arr;
    }
    astToViewFilters(rootExpression) {
        // Array of ViewFilters, i.e. search constraints as the view presents them.
        let filters = [];
        // Variables for tree traversal----------------------------------------
        // ViewFilter being currently built
        let currentViewFilter = new ViewFilter();
        // Stack for tree traversal
        let stack = [];
        // Item being currently handled
        let cur = new StackItem(rootExpression, false);
        // Returns true of operatorType represents a boolean operator of arity 2 (i.e. currently AND, OR)
        let isBooleanOperator = (operatorType) => {
            switch (operatorType) {
                case "Or":
                case "And":
                case "AndAlternative":
                    return true;
                default:
                    return false;
            }
        };
        let isArithOperator = (operatorType) => {
            return operatorType === "Plus" || operatorType === "Minus";
        };
        // Changes the visitation state of a stack item. This is done to help the tree traversal decide which node
        // to visit next. For instance, an OR-Operator will have its visitation count set to 1, if the RExpression
        // has been visited. If the LExpression has also been visited, the visitation count will be set to 2 (meaning
        // "everything done"). On the other hand, an ISNOTNULL operator will have its visitation count set to 2
        // immediately, as there are no sub-expressions to evaluate. Similarly, the visitation count for a LessThan-
        // Operator will also be set to 2 after its RExpression has been visited, as there can be no LExpression.
        // The visitation count is checked by the tree traversal algorithm to determine if a node is completely
        // processed. In this case, a backtracking occurs to the next (partially) unvisited node on the stack.
        let visit = (item) => {
            if (item) {
                // Node is an operator
                if (item.m_isOperator) {
                    let op = cur.m_node;
                    // Arity 2, possible visitation states: 0, 1, 2
                    if (isBooleanOperator(op.operatorType) || op.operatorType === "Between")
                        item.m_visited++;
                    // Arity 0 or 1, possible visitation states: 0 and 2.
                    else
                        item.m_visited = 2;
                }
                else
                    // Node is an expression, possible visitation states: 0 and 2.
                    item.m_visited = 2;
            }
        };
        // Pop the last item off the stack and update its visitation state.
        let popStack = () => {
            cur = stack.pop();
            if (cur)
                visit(cur);
            return cur || undefined;
        };
        // Algorithm: Postorder tree traversal (right subtree, i.e. RExpression first!).
        //
        // Iteratively traverse the tree, maintaining a stack of visited nodes, with an enhanced visitation state,
        // hinting whether the RExpression of an operator has already been evaluated.
        do {
            if (cur.m_isOperator) {
                let op = cur.m_node;
                switch (cur.m_visited) {
                    case 2:
                        if (!isBooleanOperator(op.operatorType) && !isArithOperator(op.operatorType)
                            && op.operatorType !== "Quotes") {
                            // "leaf operator" has been fully visited, so we can finish building
                            // the current ViewFilter and create a new one representing the next nodes that will
                            // be traversed.
                            currentViewFilter.operator = op;
                            filters.push(currentViewFilter);
                            currentViewFilter = new ViewFilter();
                        }
                        cur = popStack();
                        break;
                    case 1:
                        // This applies the boolean operator to the wrong ViewFilter, but in the resulting array,
                        // They will be only off by one index. See the correction of filters after this do-while
                        // loop for correction.
                        if (isBooleanOperator(op.operatorType))
                            currentViewFilter.externalOperator = op.operatorType;
                        stack.push(cur);
                        cur = new StackItem(op.lExpression, false);
                        break;
                    case 0:
                    default:
                        stack.push(cur);
                        cur = new StackItem(op.rExpression, false);
                        break;
                }
            }
            else {
                // FilterExpression
                if (cur.m_visited)
                    cur = popStack();
                else {
                    let fe = cur.m_node;
                    if (!fe)
                        cur = popStack();
                    else if (fe.childOperator) {
                        stack.push(cur);
                        cur = new StackItem(fe.childOperator, true);
                    }
                    else
                        cur = popStack();
                }
            }
        } while (stack.length > 0 && cur != undefined);
        // Reverse the ViewFilters array and fix the off-by-one index of the boolean operators.
        filters.reverse();
        for (let i = filters.length - 2; i >= 0; i--) {
            filters[i + 1].externalOperator = filters[i].externalOperator;
            filters[i].externalOperator = "";
        }
        if (filters.length === 0)
            filters.push({
                externalOperator: "",
                operator: {
                    lExpression: undefined,
                    rExpression: {
                        valueEscaped: "",
                        valueUnescaped: "",
                        valueFTField: "",
                        syntaxMode: "DefaultDisabled",
                        childOperator: undefined
                    },
                    operatorType: "Equals",
                    syntaxMode: "DefaultDisabled"
                }
            });
        return filters;
    }
    getUpdatedInstance() {
        let that = this;
        let inst = that.currentInstance;
        let filters = that.filterDiv.children("div.synPropertyPageExtendedSearchFilter");
        let isFTRepField = this.input.field.isFTRepresentativeField;
        let filterExpressions = [];
        let filterRepresentativeExpressions = [];
        for (let i = filters.length - 1; i >= 0; i--) {
            let filter = $(filters[i]);
            let exp = filter.synPropertyPageExtendedSearchFilter("getFilterExpression", isFTRepField);
            filterExpressions.splice(0, 0, exp);
            if (isFTRepField) {
                let exp2 = filter.synPropertyPageExtendedSearchFilter("getFilterExpression", false);
                filterRepresentativeExpressions.splice(0, 0, exp2);
            }
        }
        // Remove leading "||" or "&&" from combined expression. This might happen if the first filter
        // expression was empty.
        let startsWithExternalOperator = /^(\|\||&&)/;
        let fieldName = isFTRepField ? this.input.field.presentedField : this.input.field.fieldName;
        inst.items[fieldName].value = filterExpressions.join("").replace(startsWithExternalOperator, "");
        if (isFTRepField)
            inst.items[this.input.field.fieldName].value = filterRepresentativeExpressions.join("").replace(startsWithExternalOperator, "");
        return Promise.resolve(inst);
    }
}
exports.ExtendedSearchDialog = ExtendedSearchDialog;
ExtendedSearchDialog.InternalDateFormat = "dd-MM-yyyy HH:mm:ss";
ExtendedSearchDialog.operators = {
    None: {
        InternalName: "None",
        String: ""
    },
    Or: {
        InternalName: "Or",
        Title: "",
        TitleKey: "dynpsearchdlgor",
        TitleFallback: "Or",
        String: "||"
    },
    And: {
        InternalName: "And",
        Title: "",
        TitleKey: "dynpsearchdlgand",
        TitleFallback: "And",
        String: "&&"
    },
    Contains: {
        InternalName: "Contains",
        Title: "",
        TitleKey: "dynpsearchdlgcontains",
        TitleFallback: "contains",
        String: ""
    },
    Equal: {
        InternalName: "Equals",
        Title: "",
        TitleKey: "dynpsearchdlgequal",
        TitleFallback: "=",
        String: ""
    },
    EqualExact: {
        InternalName: "EqualsExact",
        Title: "",
        TitleKey: "dynpsearchdlgequalexact",
        TitleFallback: "=",
        String: ""
    },
    Greater: {
        InternalName: "Greater",
        Title: "",
        TitleKey: "dynpsearchdlggreater",
        TitleFallback: ">",
        String: ">"
    },
    Smaller: {
        InternalName: "Less",
        Title: "",
        TitleKey: "dynpsearchdlgsmaller",
        TitleFallback: "<",
        String: "<"
    },
    GreaterOrEqual: {
        InternalName: "GreaterOrEqual",
        Title: "",
        TitleKey: "dynpsearchdlggreaterequal",
        TitleFallback: ">=",
        String: ">="
    },
    SmallerOrEqual: {
        InternalName: "LessOrEqual",
        Title: "",
        TitleKey: "dynpsearchdlgsmallerequal",
        TitleFallback: "<=",
        String: "<="
    },
    NotContains: {
        InternalName: "NotContains",
        Title: "",
        TitleKey: "dynpsearchdlgnotcontains",
        TitleFallback: "does not contain",
        String: "<>"
    },
    NotEqual: {
        InternalName: "NotEqual",
        Title: "",
        TitleKey: "dynpsearchdlgnotequal",
        TitleFallback: "<>",
        String: "<>"
    },
    NotEqualExact: {
        InternalName: "NotEqualExact",
        Title: "",
        TitleKey: "dynpsearchdlgnotequalexact",
        TitleFallback: "not equal",
        String: "<>"
    },
    Between: {
        InternalName: "Between",
        Title: "",
        TitleKey: "dynpsearchdlgbetween",
        TitleFallback: "between",
        String: "BETWEEN"
    },
    Plus: {
        InternalName: "Plus",
        Title: "+",
        String: "PLUS"
    },
    Minus: {
        InternalName: "Minus",
        Title: "-",
        String: "MINUS"
    },
    IsNull: {
        InternalName: "IsNull",
        Title: "",
        TitleKey: "dynpsearchdlgisnull",
        TitleFallback: "is undefined",
        String: "ISNULL"
    },
    IsNotNull: {
        InternalName: "IsNotNull",
        Title: "",
        TitleKey: "dynpsearchdlgisnotnull",
        TitleFallback: "is not undefined",
        String: "ISNOTNULL"
    },
    Quotes: {
        InternalName: "Quotes",
        String: "\""
    }
};
ExtendedSearchDialog.initOperators = function () {
    Object.keys(ExtendedSearchDialog.operators).forEach(function (key) {
        let operator = ExtendedSearchDialog.operators[key];
        if (operator["TitleKey"])
            operator["Title"] = Utilities_1.synUtil.Strings.getValue(operator["TitleKey"], operator["TitleFallback"]);
    });
    Utilities_1.synUtil.Strings.getValue("dynpsearchdlgor", "Or");
};
